import { faqSlice } from "store/slices/faqSlice";
import { AppDispatch } from "@/store/store";

const { search } = faqSlice.actions;

export const setSearchQuery = (query: string) => (dispatch: AppDispatch) => {
  dispatch(search(query));
};
